import endpoint from 'utils/endpoint';

import { virtualClinicPatientProfilesAppointmentsRoute } from 'lib/apiRoutes';

import * as types from './types';

// eslint-disable-next-line import/prefer-default-export
export const fetchVirtualClinicPatientAppointmentsEndpoint = patientId => endpoint(types.FETCH_VIRTUAL_CLINIC_PATIENT_APPOINTMENTS, 'GET', virtualClinicPatientProfilesAppointmentsRoute(patientId));
